import CRMAddContactTagForm from './CRMAddContactTagForm';

export default CRMAddContactTagForm;
